// PC-3: pure helpers for embedded-mode boot. parseEmbedParams reads the iframe URL;
// pickConversationToSelect only opens a deep-linked conversation the user is a member of
// (i.e. it appears in their loaded conversation list) - never reveals a non-member id.
export function parseEmbedParams(search: string): { embed: boolean; conversation: string | null } {
  const p = new URLSearchParams(search);
  return { embed: p.get('embed') === '1', conversation: p.get('conversation') };
}

export function pickConversationToSelect(
  requested: string | null,
  conversationIds: string[],
): string | null {
  if (!requested) return null;
  return conversationIds.includes(requested) ? requested : null;
}
